<script>
export const group = 'TopLeft'
</script>

<script setup>
const gsapTimeline = useGsapTimeline()
const props = defineProps({
  item: Object,
})

const textElement = ref(null)
const textElementChildren = ref(null)

const doAppear = async () =>
  gsapTimeline({ name: 'Announcement Appear' }).fromTo(
    textElementChildren,
    { visibility: 'hidden', scale: 0.3, transformOrigin: 'bottom center' },
    { scale: 1, visibility: 'inherit', duration: 0.08, stagger: { amount: 0.24 }, ease: 'power1.Out' }
  )

const doDisappear = async () =>
  gsapTimeline({ name: 'Announcement Disappear' })
    .to(textElement, { letterSpacing: '-6px', duration: 0.125, ease: 'power3.In' })
    .to(shuffle(textElementChildren), { letterSpacing: 0, scale: 0.3, visibility: 'hidden', duration: 0.08, stagger: { amount: 0.12 }, ease: 'power1.Out' }, '<.04')

const text = computed(() => props.item.properties.text)

onMounted(doAppear)

const { onDisappear } = useDisappearable()
onDisappear(doDisappear)
</script>

<template>
  <SplitCharacters :key="text" :text="text" class="text-q-cr-red-primary text-[40px] font-semibold" childClass="invisible" @container="textElement = $event" @children="textElementChildren = $event" />
</template>
